import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
import { NotificationsNoneRounded } from '@material-ui/icons';

import { SideBarDialog } from 'shared/components';
import { ComplaintCard, MenuTabs, NoveltyCard } from './components';

import { useMozartMainDialog } from './hooks';

import makeClasses from './MozartMainDialog.style';

import type { UseMozartMainDialogProps } from './hooks';
import type { SideBarDialogProps } from 'shared/components/side-bar-dialog';

export function MozartMainDialog(props: Props) {
  const {
    isLoading,
    novelties,
    complaints,
    onSelectComplaint,
    ...restProps
  } = props;

  const {
    lang,
    isEmpty,
    showTheTab,
    showTheList,
    storeSelector,
    menuTabSelected,
    complaintsToRender,
    numberOfNotSeenToTabs,
    handleOnSelectNovelties,
    handleOnSelectComplaints,
    handleClickNoveltiesSection,
    handleClickComplaintsSection,
  } = useMozartMainDialog({
    isLoading,
    novelties,
    complaints,
    onSelectComplaint,
  });

  const _classes = makeClasses();

  return (
    <SideBarDialog
      aria-label='mozart-main-dialog'
      headerTitle={lang.header.title}
      classesHeader={{ title: _classes.headerDialogTitle }}
      classesMain={{ main: _classes.mainDialog }}
      posNav={
        <MenuTabs
          showTab={showTheTab}
          menuTabSelected={menuTabSelected}
          numberOfNotSeen={numberOfNotSeenToTabs}
          onSelectNovelties={handleOnSelectNovelties}
          onSelectComplaints={handleOnSelectComplaints}
        />
      }
      {...restProps}
    >
      {isLoading && (
        <div className={_classes.loadingContainer}>
          <CircularProgress
            size='6rem'
            thickness={4}
            className={_classes.loading}
          />
        </div>
      )}

      {isEmpty && (
        <div className={_classes.emptyState}>
          <NotificationsNoneRounded className={_classes.emptyStateIcon} />
          <h6 className={_classes.emptyStateTitle}>{lang.emptyState.title}</h6>
          <p className={_classes.emptyStateBody}>{lang.emptyState.body}</p>
        </div>
      )}

      {showTheList.novelties && (
        <section onClick={handleClickNoveltiesSection}>
          {novelties.map(n => (
            <NoveltyCard
              key={n.id}
              novelty={n}
              data-novelty-id={n.id}
              data-created-at={n.createdAt}
            />
          ))}
        </section>
      )}

      {showTheList.complaints && (
        <section className={_classes.complaintsSection}>
          {storeSelector.isMultiple && (
            <FormControl fullWidth variant='filled'>
              <InputLabel className={_classes.labelOfFilterByStore}>
                {lang.filterByStore.label}
              </InputLabel>
              <Select
                disableUnderline
                value={storeSelector.id}
                onChange={storeSelector.handleSelectedStoreId}
                classes={{ root: _classes.selectOfFilterByStore }}
              >
                {storeSelector.list.map(store => (
                  <MenuItem key={store.id} value={store.id}>
                    {store.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
          <div aria-label='complaints' onClick={handleClickComplaintsSection}>
            {complaintsToRender.map(c => (
              <ComplaintCard
                key={c.id}
                complaint={c}
                data-complaint-id={c.id}
                data-store-id={c.storeId}
              />
            ))}
          </div>
        </section>
      )}
    </SideBarDialog>
  );
}

interface Props extends Partial<SideBarDialogProps>, UseMozartMainDialogProps {}
